import React from "react";
import { HeaderNav } from "../components/HeaderNav";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Experience } from "../components/Experience";
import { Projects } from "../components/Projects";
import { Skills } from "../components/Skills";
import { ResumeCTA } from "../components/ResumeCTA";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function Portfolio() {
  return (
    <div className="grain relative">
      <HeaderNav />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <ResumeCTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
